<div class="ov column" (click)="itemClickHandler()">
  {{ item.number || '---' }}
</div>
<div class="timestamp column" (click)="itemClickHandler()">
  {{ date || '---' }}
</div>
<div class="products column" (click)="itemClickHandler()">
  <div class="product" *ngFor="let p of item.products" [matTooltip]="p.name">{{ p.name || '---' }}</div>
</div>
<div class="quantity column" (click)="itemClickHandler()">
  <div *ngFor="let p of item.products">{{ p.quantity.required || '---' }}</div>
</div>
<div class="status column" (click)="itemClickHandler()">
  {{ translateStatus(item.status) }}
</div>
<div class="progress column">
  <mat-progress-bar mode="determinate" [value]="progressValue" matTooltip="{{progressValue.toFixed(1)}}%"></mat-progress-bar>
</div>

